import React from 'react'
import ReactDOM from 'react-dom'
import App from './routing'
import firebase_config from "./config"
import {EMAILJS_USER} from './config'
import Firebase from "firebase/app"
import{ init } from 'emailjs-com'

import './index.css'

Firebase.initializeApp(firebase_config)
init(EMAILJS_USER)

ReactDOM.render(<App />, document.getElementById('root'))
